import React from 'react';
import './JewelleryPlans.css';

const plans = [
    {
        name: "SWARNAM",
        subtitle: "Jewellery Purchase Plan",
        description: "Pay for 11 months, get 1 month free. Installments from ₹1000 to ₹15000. Use for in-store or custom gold jewellery.",
        benefits: [
            "11 monthly installments",
            "1 month bonus amount",
            "Flexible from ₹1000 to ₹15000",
            "Buy in-store or custom jewellery",
        ],
    },
    {
        name: "GOWRI",
        subtitle: "For Students",
        description: "Exclusively for students. Pay ₹500/month for 11 months and get 2 months bonus.",
        benefits: [
            "11 monthly installments of ₹500",
            "2 month bonus amount",
            "Buy coins, in-store, or custom jewellery",
        ],
    },
    {
        name: "SAMPATTI",
        subtitle: "Jewellery Pre-Booking Plan",
        description: "Book at today’s gold price, avoid future price hikes. Zero making charges (up to 18%).",
        benefits: [
            "Book gold at today's rate",
            "Zero making charges (up to 18%)",
            "Get jewellery after 11 months",
        ],
    },
    {
        name: "KUBERA",
        subtitle: "Zero Making Charges Plan",
        description: "Pay no making charges up to 18% on gold and up to 50% off on diamonds.",
        benefits: [
            "0% making charges (up to 18%) on gold",
            "Up to 50% off on diamond jewellery",
            "Pay extra only for making charges beyond 18%",
        ],
    },
];

export default function JewelleryPlans() {
    return (
        <section className="plans-section">
            <h2 className="plans-heading">Jewellery Purchase Plans</h2>
            <div className="plans-grid">
                {plans.map((plan, idx) => (
                    <div key={idx} className="plan-card">
                        <h3 className="plan-title">{plan.name}</h3>
                        <p className="plan-subtitle">{plan.subtitle}</p>
                        <p className="plan-description">{plan.description}</p>
                        <ul className="plan-benefits">
                            {plan.benefits.map((benefit, i) => (
                                <li key={i}>{benefit}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}
